jQuery(document).ready(function($) {
  //   if (navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i)){
  //     $('#mobileHelpButton').show();
  //     $('#desktopHelpButton').hide();
  //   }
  if (navigator.userAgent.match(/Android|BlackBerry|Opera Mini|IEMobile/i)){
    $('#mobileAndroidHelpButton').show();
    $('#desktopHelpButton').hide();
  }
  if (navigator.userAgent.match(/iPhone|iPad|iPod/i)){
    $('#mobileIOSHelpButton').show();
    $('#desktopHelpButton').hide();
  }
  var modal = document.getElementById("helpNowModal");

  // This controls mobile view only
  // set height and width of iframe after page load, assuming
  $('#liveHelpIframe').width(
    ($( window ).width() - 75)
  );
  $('#liveHelpIframe').height(
    ($( window ).height() - 50)
  );

  // when the user clicks the image, open the modal
  $('#livehelpbutton').on('click', function() {
    $('.modal--livehelpnow').show()
  })

  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  };

  $('#closeModalBox').on('click', function() {
    $('.modal--livehelpnow').hide();
    console.log('click!')
  });

});
